module.exports = __webpack_public_path__ + "media/images/elionline/icons/side_menu_home_attivo-9181973965fe2466aa36fc9a4f4909fc.svg";